import { render, staticRenderFns } from "./MUserBatchWidget.vue?vue&type=template&id=5ee65c47&lang=pug&"
import script from "./MUserBatchWidget.vue?vue&type=script&lang=js&"
export * from "./MUserBatchWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports